import { useState, useEffect } from 'react';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import MarketAnalysisChart from '@Components/DataAnalysis/MarketAnalysisChart';
import { sandhillsRequest, insertURLParameter, removeURLParameter } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
const CreatedOnUTCDateTime = 'CreatedOnUTCDateTime';
const SoldUTCDateTime = 'SoldUTCDateTime';
import { LinkRelationTypes } from '@Components/Utilities/SandhillsConstants';

const MarketAnalysis = (props) => {

    const currentUser = useRecoilValue(atoms.currentUser);
    const routes = useRecoilValue(atoms.routes);
    const [chartData, setChartData] = useState({
        Retail: props.Retail,
        Auction: props.Auction,
        RetailData: props.RetailData,
        AuctionData: props.AuctionData,
        RetailLineData: props.RetailLineData,
        AuctionLineData: props.AuctionLineData,
        AuctionURL: props.AuctionPageURL,
        ListingURL: props.ListingPageURL,
        DisableRetailLink: props.DisableRetailLink
    });

    useEffect(() => {
        if (!props.TooManyResults) {
            loadChartData();
        }
    }, []);

    useEffect(() => {
        if (props.reloadChart) {
            loadChartData();
        }
    }, [props.reloadChart]);

    const loadChartData = () => {
        sandhillsRequest({
            url: props.MarketAlanysisURL,
            method: 'post',
            errorHandling: {
                message: 'Error retrieving market analysis data. Please refresh your page.',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            if (response) {
                setChartData(previousState => {
                    return {
                        ...previousState,
                        Retail: response.Retail,
                        Auction: response.Auction,
                        RetailData: response.RetailData,
                        AuctionData: response.AuctionData,
                        RetailLineData: response.RetailLineData,
                        AuctionLineData: response.AuctionLineData,
                        AuctionURL: response.AuctionPageURL,
                        ListingURL: response.ListingPageURL,
                        DisableRetailLink: response.DisableRetailLink
                    };
                });
            }
        });
    }


    const toggleChart = () => {
        props.setShowChart(!props.ShowChart);
    }

    const TimeChanged = (timeSpan) => {
        let fullURL = props.MarketAlanysisURL;
        fullURL = removeURLParameter(fullURL, CreatedOnUTCDateTime);
        fullURL = removeURLParameter(fullURL, SoldUTCDateTime);

        fullURL = insertURLParameter(fullURL, CreatedOnUTCDateTime, timeSpan.StartDate);
        fullURL = insertURLParameter(fullURL, SoldUTCDateTime, timeSpan.StartDate);
        sandhillsRequest({
            url: fullURL,
            method: 'post',
            errorHandling: {
                message: 'Error retrieving market analysis data. Please refresh your page.',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            setChartData(previousState => {
                return {
                    ...previousState,
                    Retail: response.Retail,
                    Auction: response.Auction,
                    RetailData: response.RetailData,
                    AuctionData: response.AuctionData,
                    RetailLineData: response.RetailLineData,
                    AuctionLineData: response.AuctionLineData,
                    AuctionURL: response.AuctionPageURL,
                    ListingURL: response.ListingPageURL,
                    DisableRetailLink: response.DisableRetailLink
                };
            });
        });
    }

    return (
        <div className='market-analysis-container'>
            <div className='market-analysis-header'>
                <h3><i className='fas fa-up-long' /><i className='fas fa-down-long' />&nbsp;<TranslationText tKey='sandhills.tradepubwebsite.mvc.hilowaverage' /></h3>
                {currentUser?.IsAuthenticated && !currentUser?.IsMinReg ?
                    <>
                        {props.TooManyResults ?
                            <div className='refine-search'>
                                <span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradesites.mvc.pleaserefinesearch') }} />
                            </div>
                            :
                            <div className='login-buttons'>
                                <div className='login-button'>
                                    <span><b><TranslationText tKey='sandhills.tradesites.mvc.auctionvalue' />:</b></span><br />
                                    <div class='price'>{props.Auction?.AveragePrice}</div>
                                </div>
                                <div className='login-button'>
                                    <span><b><TranslationText tKey='sandhills.tradesites.mvc.retailvalue' />:</b></span><br />
                                    <div className='price'>{props.Retail?.AveragePrice}</div>
                                </div>
                            </div>
                        }
                    </>
                    :
                    {
                        ...currentUser?.IsMinReg && currentUser?.IsAuthenticated ?
                            <div className='login-buttons'>
                                <div className='login-button'>
                                    <span><b><TranslationText tKey='sandhills.tradesites.mvc.auctionvalue' />:</b></span><br />
                                    <a href={routes.FullRegistrationRoute} rel={LinkRelationTypes.noFollow}><TranslationText tKey='sandhills.tradesitesmvc.completelogintoseemore' /></a>
                                </div>
                                <div className='login-button'>
                                    <span><b><TranslationText tKey='sandhills.tradesites.mvc.retailvalue' />:</b></span><br />
                                    <a href={routes.FullRegistrationRoute} rel={LinkRelationTypes.noFollow}><TranslationText tKey='sandhills.tradesitesmvc.completelogintoseemore' /></a>
                                </div>
                            </div>
                            :
                            <div className='login-buttons'>
                                <div className='login-button'>
                                    <span><b><TranslationText tKey='sandhills.tradesites.mvc.auctionvalue' />:</b></span><br />
                                    <a href={routes.SSO} rel={LinkRelationTypes.noFollow}><TranslationText tKey='sandhills.tradesites.mvc.logintoseemoredetails' /></a>
                                </div>
                                <div className='login-button'>
                                    <span><b><TranslationText tKey='sandhills.tradesites.mvc.retailvalue' />:</b></span><br />
                                    <a href={routes.SSO} rel={LinkRelationTypes.noFollow}><TranslationText tKey='sandhills.tradesites.mvc.logintoseemoredetails' /></a>
                                </div>
                            </div>
                    }
                }
            </div>
            {currentUser?.IsAuthenticated && !props.TooManyResults && !currentUser?.IsMinReg &&
                <div className='chart-container'>
                    {props.ShowChart &&
                        <MarketAnalysisChart {...chartData} TimeChanged={TimeChanged} DisableRetailLink={chartData.DisableRetailLink} ListingPageURL={chartData.ListingURL} AuctionPageURL={chartData.AuctionURL} TimeSpansAvailable={props.TimeSpansAvailable} />
                    }
                    <span className='toggle-section'>
                        <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleChart(); } }} className='chart-button' onClick={toggleChart}>{props.ShowChart ? <TranslationText tKey='sandhills.tradesites.mvc.moredetails' /> : <TranslationText tKey='sandhills.tradesites.mvc.moredetails' />}&nbsp;<i className={props.ShowChart ? 'fas fa-angle-up' : 'fas fa-angle-down'} /></div>
                    </span>
                </div>
            }

        </div>
    );
};

export default MarketAnalysis;